import React from 'react';

import Data from 'data';
import itemTooltip from 'logic/itemTooltip';
import { RawTooltip } from 'ui/tooltip';
import GameTooltip from './GameTooltip';

import Store from 'store';
import { presetItems } from 'logic/itemTypes';
import { itemCreateTemplate } from 'logic/itemReducers';
import { selectStats } from 'logic/stats';
import skillTooltip from 'logic/skills/tooltip';
import { useAlt, useShift } from 'ui/modifiers';

export const D2Tooltip = ({ tooltip, ...props }) => <RawTooltip {...props} tooltip={(
  <div className="d2-tooltip-wrapper">
    {tooltip}
  </div>
)}/>;

export function ItemTooltip({ item, type, merc }) {
  const state = Store.useState();
  const text = React.useMemo(() => itemTooltip(item, state, merc, type), [item, state, merc, type]);
  return <GameTooltip text={text}/>;
}

function ItemTooltipCompare({ item, merc }) {
  const type = Data.itemTypes[Data.items[item?.base]?.type];
  const slot1 = type?.bodyloc1, slot2 = type?.bodyloc2;
  const comp1 = Store.useSelector(state => {
    if (!slot1) return null;
    const profile = state.profiles[state.activeProfile];
    const id = (merc ? profile.mercItems : profile.items)[slot1];
    if (!id) return null;
    const item1 = state.items[id];
    return item1 === item ? null : item1;
  });
  const comp2 = Store.useSelector(state => {
    if (!slot2) return null;
    const profile = state.profiles[state.activeProfile];
    const id = (merc ? profile.mercItems : profile.items)[slot2];
    if (!id) return null;
    const item2 = state.items[id];
    return item2 === item ? null : item2;
  });
  const isShift = useShift();
  const isAlt = useAlt();

  if ((!comp1 && !comp2) || !isShift || item.template) return <ItemTooltip item={item} merc={merc}/>;
  return <>
    <ItemTooltip item={item} merc={merc}/>
    {(comp1 && comp2 && isAlt) ? <ItemTooltip item={comp2} merc={merc}/> : <ItemTooltip item={comp1 || comp2} merc={merc}/>}
  </>;
}

function ItemTooltipById({ id, merc }) {
  const item = Store.useItem(id) || presetItems[id];
  if (!item) return <GameTooltip text={["\\xffc1Invalid Item"]}/>;
  return <ItemTooltipCompare item={item} merc={merc}/>;
}

function ItemTooltipBase({ id, type, merc }) {
  const item = itemCreateTemplate(id, type);
  if (!item) return null;
  return <ItemTooltip item={item} type={type} merc={merc}/>;
}

export function D2ItemTooltip({ id, item, base, merc, type, ...props }) {
  let tooltip = null;
  if (id) {
    tooltip = <ItemTooltipById id={id} merc={merc}/>;
  } else if (item) {
    tooltip = <ItemTooltipCompare item={item} merc={merc}/>;
  } else if (base) {
    tooltip = <ItemTooltipBase id={base} type={type} merc={merc}/>;
  }
  return <D2Tooltip {...props} tooltip={tooltip}/>;
}

function SkillTooltip({ id, unit='player', level, full=true, canLevel=false }) {
  const stats = Store.useSelector(selectStats)[unit];
  const text = React.useMemo(() => skillTooltip(id, stats, full, canLevel, level), [id, stats, full, canLevel, level]);
  return <GameTooltip text={text}/>;
}

export function D2SkillTooltip({ id, unit='player', full=true, level, canLevel=false, ...props }) {
  return <D2Tooltip {...props} tooltip={<SkillTooltip id={id} unit={unit} full={full} level={level} canLevel={canLevel}/>}/>;
}
